export const JOB_CONTACT_FORM_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export const JOB_CONTACT_FORM_ALLOWED_DOCUMENT_EXTENSIONS = [
  ".pdf",
  ".doc",
  ".docx",
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
] as const;

export const JOB_CONTACT_FORM_ALLOWED_DOCUMENT_MIME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/jpeg",
  "image/png",
  "image/webp",
] as const;

export const JOB_CONTACT_FORM_ALLOWED_DOCUMENT_TYPES_LABEL =
  "PDF, DOC, DOCX, JPG oder JPEG, PNG oder WEBP";

export const formatContactFormFileSize = (sizeInBytes: number): string => {
  if (sizeInBytes >= 1024 * 1024) {
    return `${Math.round(sizeInBytes / 1024 / 1024)} MB`;
  }

  return `${Math.max(1, Math.round(sizeInBytes / 1024))} KB`;
};

export const getJobContactFormDocumentTypeErrorMessage = (
  fileName: string
): string => {
  const isSvgFile = fileName.toLowerCase().endsWith(".svg");

  if (isSvgFile) {
    return `Die Datei ${fileName} kann nicht hochgeladen werden. SVG-Dateien werden nicht unterstützt. Erlaubt sind ${JOB_CONTACT_FORM_ALLOWED_DOCUMENT_TYPES_LABEL}.`;
  }

  return `Die Datei ${fileName} kann nicht hochgeladen werden. Erlaubt sind ${JOB_CONTACT_FORM_ALLOWED_DOCUMENT_TYPES_LABEL}.`;
};
